
import { iconFactory } from '../../utils/iconFactory';

export const PrinterIcon = iconFactory({
  componentName: 'PrinterIcon',
  viewBox: '0 0 32 32',
  title: 'printer',
  g: `<path d="M9.696 20.288h12.8v6.464h-12.8v-6.464zM9.216 11.36h-1.728v-7.2c0-0.96 0.768-1.728 1.728-1.728h8.608c0.96 0 2.304 0.512 3.040 1.088l2.528 2.112c0.736 0.608 1.312 1.888 1.312 2.816v2.912h-15.488zM19.552 7.072c0 0.48 0.384 0.864 0.864 0.864h2.336c-0.128-0.256-0.288-0.512-0.448-0.64l-2.528-2.112c-0.064-0.064-0.128-0.096-0.224-0.16v2.048zM28.16 14.464v8.608c0 0.96-0.768 1.728-1.728 1.728h-0.864v2.88c0 1.088-0.896 1.984-1.984 1.984h-14.88c-1.088 0-1.984-0.896-1.984-1.984v-2.88h-0.96c-0.96 0-1.728-0.768-1.728-1.728v-8.608c0-0.96 0.768-1.728 1.728-1.728h20.672c0.928 0.032 1.728 0.8 1.728 1.728zM26.272 19.648c0-0.32-0.256-0.576-0.576-0.576h-18.88c-0.32 0-0.576 0.256-0.576 0.576v1.696c0 0.288 0.224 0.512 0.48 0.576 0.032 0 0.064 0.032 0.096 0.032h1.536v4.384c0 0 0 0 0 0v1.376c0 0.192 0.16 0.352 0.352 0.352h14.88c0.192 0 0.352-0.16 0.352-0.352v-5.824h1.76c0.32 0 0.576-0.256 0.576-0.576v-1.664z"/>`,
  gThemed: {
    // No themed variants provided
  },
});

export default PrinterIcon;
